import React from "react";
import Highlighter from "react-highlight-words";
import {Avatar, Col, Row} from "antd";

type User = {
    id: string,
    name: string,
    email: string
}

type UserProps = {
    user: User,
    match: string
}


function User(props: UserProps) {
    return (
        <Row gutter={[8, 0]}>
            <Col flex={"none"} className={"gt-d-flex-center"}>
                <Avatar className={"giro-user-avatar"} shape={"square"} ><i className="bi bi-person-fill"></i></Avatar>
            </Col>
            <Col flex={"auto"}>
                <Highlighter
                    searchWords={props.match.split(" ")}
                    autoEscape={true}
                    textToHighlight={props.user.name}
                />
                <div className={"giro-fs-12"}>
                    {props.user.email}
                </div>
            </Col>
        </Row>
    );
}

export default User;